let hyphenToCamel = (s) => {
  return s.replace(/(-\w)/g, m => {return m[1].toUpperCase();});
}


export default {
  hyphenToCamel: hyphenToCamel,
};



// WEBPACK FOOTER //
// ./src/components/utils.jsx